import React, { useEffect } from 'react';

import TabContainer from '../../../../common/components/tab/containers/tab.containers';
import { GlobalShipXAgencyBasicInfoComponent } from './global-shipx-agency-basic-info';

export const GlobalShipxAgencyComponent = ({id,selectedGlobalShipXMapping,handleInnerFormChange,back,dodProgramParticipants,channelPrograms
}: any) => {
  
  const tabItems = [
    {
         id: 1,
         title: 'Basic Info',
         component: <GlobalShipXAgencyBasicInfoComponent
         selectedGlobalDODMapping={selectedGlobalShipXMapping}
         handleInnerFormChange={handleInnerFormChange}
           dodProgramParticipants={dodProgramParticipants}
           channelPrograms={channelPrograms}
           id={id}
         />,
         isVisible: true,
       },
  ]
 


  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">

<TabContainer tabItems={tabItems}/>

      <div className='flex w-full justify-end items-end'>
        <button
          onClick={back}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
        >
          Back
        </button>
        </div>
    </div>
  )
}
export default GlobalShipxAgencyComponent;
